import React, { useEffect, useState } from "react";
import { X, Calendar, PenToolIcon as Tool } from "lucide-react";
import GreyArrow from "../assets/greyLeftAr.png";
import { Button, ButtonGroup } from "@mui/material";
import "./Css/PickUpForm.css";
import Header from "./Header";
import {
  APL_LINK,
  server_post_data,
  get_pickup_data_admin,
  save_image_pdf_dashboard,
  submit_update_drop_data,
} from "../ServiceConnection/serviceconnection";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import {
  handleAphabetsChange,
  handleError,
  handleNumbersChange,
  handleSuccess,
  handleSuccessSession,
  goBack,
  formatToYYYYMMDD,
} from "../CommonJquery/CommonJquery";
import { useParams } from "react-router-dom";
import { retrieveData } from "../LocalConnection/LocalConnection";

import { useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Loader from "./Loader.js";
import Breadcrumb from "../CommonJquery/Breadcrumb.js";
export default function DropOfForm() {
  const admin_name = retrieveData("admin_name");

  const location = useLocation();
  const pathname = location.pathname;
  const { id } = useParams();
  const today_date = new Date().toISOString().split("T")[0];
  const [activeStep, setActiveStep] = useState(1);
  const [carData, setCarData] = useState([]);
  const [MultiCarData, setMultiCarData] = useState([]);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [imageLink, setImageLink] = useState(false);
  const [formData, setFormData] = useState({
    Submitter: admin_name,
    drop_of_date: today_date,
    first_name: "",
    last_name: "",
    ipass: "",
    ipass_id: "",
    insurance: "",
    time: "",
    dashboardOdoImage: null,
    odoReading: "",
    ipassImg: null,
    // carImage: [],
    DamgeImage: [],
    frontLeft: null,
    frontRight: null,
    backLeft: null,
    backRight: null,
    keyImg: null,
    InsuranceCopy: null,
    vinnumber: "",
    registration_copy: null,
    inspection_copy: null,
    claims_type: "",
    keyStatus: "",
    dirty_car_img: null,
    claims: "no",
    notes: "",
    Damagenotes: "",
  });
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hoveredIndex2, setHoveredIndex2] = useState(null);
  const [step1Error, setStep1Error] = useState({
    Submitter: false,

    //
    drop_of_date: false,
    first_name: false,
    last_name: false,
    insurance: false,
    time: false,
  });
  const [step2Error, setStep2Error] = useState({
    ipassImg: false,
    keyImg: false,
    odoReading: false,
    ipass: false,
    vinnumber: false,
    dashboardOdoImage: false,
  });

  const [step3Error, setstep3Error] = useState({
    // carImage: false,
    frontLeft: false,
    frontRight: false,
    backLeft: false,
    backRight: false,
  });

  const validateStep1 = () => {
    const errors = {
      Submitter: formData?.Submitter?.trim() === "",
      drop_of_date: !formData?.drop_of_date,

      first_name: formData?.first_name?.trim() === "",
      last_name: formData?.last_name?.trim() === "",

      insurance: formData?.insurance?.trim() === "",
      time: formData?.time?.trim() === "",
    };

    return errors;
  };
  const validateStep2 = () => {
    const errors2 = {
      dashboardOdoImage: !formData?.dashboardOdoImage,
      odoReading: formData?.odoReading?.trim() === "",

      // ipass: formData.ipass.trim() === "" || formData.ipass.trim().length !== 5,

      // Check if VIN number is present and has exactly 8 digits
      vinnumber:
        formData?.vinnumber?.trim() === "" ||
        formData?.vinnumber?.trim().length !== 6,
      ipassImg: !formData.ipassImg,
      keyImg: !formData.keyImg,
    };
    return errors2;
  };

  const validateStep3 = () => {
    const errors3 = {
      // carImage: formData.carImage.length === 0,
      frontLeft: !formData.frontLeft,
      frontRight: !formData.frontRight,
      backLeft: !formData.backLeft,
      backRight: !formData.backRight,
    };

    return errors3;
  };

  const toggleDatePicker = () => {
    setIsDatePickerOpen(!isDatePickerOpen);
  };

  const handleDateChange = (date, fieldName, errorStateSetter) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: date,
    }));
    errorStateSetter((prev) => ({
      ...prev,
      [fieldName]: !date,
    }));
    setIsDatePickerOpen(false);
  };

  const handleInputChange = (e, field, step) => {
    const value = e.target.value;

    // Update the form data
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));

    // Special validation for IPASS and VIN fields
    if (field === "ipass") {
      setStep2Error((prev) => ({
        ...prev,
        [field]: value?.trim() === "" || value?.trim().length !== 5,
      }));
    } else if (field === "vinnumber") {
      setStep2Error((prev) => ({
        ...prev,
        [field]: value?.trim() === "" || value?.trim().length !== 6,
      }));
    }
    // Standard validation for other fields
    else if (value?.trim() !== "") {
      if (step === 1) {
        setStep1Error((prev) => ({ ...prev, [field]: false }));
      } else if (step === 2) {
        setStep2Error((prev) => ({ ...prev, [field]: false }));
      }
    }
  };

  const handleFileChange = async (e, field) => {
    const file = e.target.files[0];

    if (file) {
      setstep3Error((prev) => ({
        ...prev,
        [field]: false,
      }));

      await handleSaveImageBackend(file, "single", field);
    }
  };

  const handleRemoveImageSingleImg = (field, inputId) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: null, // Clear the image array (set it to empty array)
    }));

    // Reset the file input field after removing the image
    const inputElement = document.getElementById(inputId);
    if (inputElement) {
      inputElement.value = null; // Clear the file input field
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };
  const handleNext = (e, step) => {
    e.preventDefault();
    const errors = validateStep1();

    setStep1Error(errors);

    if (Object.values(errors).includes(true)) {
      return;
    }
    setActiveStep(2);
  };
  const handleNext2 = (e, step) => {
    e.preventDefault();
    const errors2 = validateStep2();
    setStep2Error(errors2);
    if (Object.values(errors2).includes(true)) {
      return;
    }
    setActiveStep(3);
  };
  console.log(MultiCarData);
  const handleNext3 = async (e) => {
    e.preventDefault();
    const errors3 = validateStep3();
    setstep3Error(errors3);
    if (Object.values(errors3).includes(true)) {
      return;
    }
    let fd_from = new FormData();

    fd_from.append("primary_id", id);
    fd_from.append("car_id", carData.primary_id);
    fd_from.append("pickup_date", formatToYYYYMMDD(formData.drop_of_date));
    fd_from.append("fname", formData.first_name);
    fd_from.append("lname", formData.last_name);
    fd_from.append("ipass_id", formData.ipass_id);
    fd_from.append("odo_reading", formData.odoReading);
    fd_from.append("Insurance", formData.insurance);
    fd_from.append("pickup_time", formData.time);
    fd_from.append("gas_and_odo_image", formData.dashboardOdoImage);
    fd_from.append("ipass_picture", formData.ipassImg);
    fd_from.append("Submitter", formData.Submitter);
    fd_from.append("key_image", formData.keyImg);
    fd_from.append("Insurance_image", formData.InsuranceCopy);
    fd_from.append("vin", formData.vinnumber);
    fd_from.append("last_maintenance_date", formData.maintenance_due);
    fd_from.append("registration", formData.registration_copy);
    fd_from.append("inspection", formData.inspection_copy);
    fd_from.append("notes", formData.notes);
    fd_from.append("Damagenotes", formData.Damagenotes);
    fd_from.append("keyStatus", formData.keyStatus);
    fd_from.append("dirty_car_img", formData.dirty_car_img);
    fd_from.append("claims", formData.claims);
    fd_from.append("claims_type", formData.claims_type);
    fd_from.append("frontLeft", formData.frontLeft);
    fd_from.append("frontRight", formData.frontRight);
    fd_from.append("backLeft", formData.backLeft);
    fd_from.append("backRight", formData.backRight);
    fd_from.append("DamgeImage", JSON.stringify(formData.DamgeImage));

    if (pathname.includes("SwitchForm")) {
      fd_from.append("drop_repo_status", 1);
    } else if (pathname.includes("DropOfForm")) {
      fd_from.append("drop_repo_status", 0);
    }

    setshowLoaderAdmin(true);
    await server_post_data(submit_update_drop_data, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          handleSuccessSession(Response.data.message, "/Bookings");
        }
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
        handleError("network");
      });
  };

  const handleImageChange = async (e, field, type) => {
    const files = e.target.files;

    const currentImages = formData[field];

    if (files.length + currentImages.length <= 5) {
      const newFiles = Array.from(files);
      await handleSaveImageBackend(e.target.files, "multi", field);
      // setFormData((prevData) => ({
      //     ...prevData,
      //     [field]: [...prevData[field], ...newFiles],
      // }));
      // setstep3Error((prev) => ({ ...prev, [field]: false }));
    } else {
      alert("You can upload a maximum of 5 images.");
    }
  };

  const handleRemoveImage = (index, field, inputId) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: prevData[field].filter((_, i) => i !== index),
    }));
    const inputElement = document.getElementById(inputId);
    if (inputElement) {
      inputElement.value = null;
    }
  };

  const handleChangeNotes = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleClaimsChange = (e) => {
    const { value } = e.target;
    setFormData({
      ...formData,
      claims: value,
    });
  };

  useEffect(() => {
    master_data_get();
  }, []);
  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("booking_id", id);
    await server_post_data(get_pickup_data_admin, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          const booking_data = Response.data.message.booking_data;
          setCarData(Response.data.message.car_data);
          setFormData({
            first_name: booking_data.first_name || "",
            last_name: booking_data.last_name || "",
            Submitter: admin_name,
            drop_of_date: today_date,
            ipass: booking_data.ipass_number,
            ipass_id: booking_data.ipass_id,
            insurance: booking_data.insurance,
            time: "",
            dashboardOdoImage: null,
            odoReading: "",
            // ipassImg: booking_data.ipass_picture,
            ipassImg: "",
            // carImage: [],
            DamgeImage: [],
            keyImg: null,
            InsuranceCopy: null,
            vinnumber: booking_data.vin,
            registration_copy: null,
            inspection_copy: null,

            keyStatus: "",
            dirty_car_img: null,
            claims: "no",
            notes: "",
            Damagenotes: "",
          });
        }
        setImageLink(APL_LINK + Response.data.message.other_images_link);
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSaveImageBackend = async (images, keyword, field) => {
    try {
      setshowLoaderAdmin(true);
      const fd = new FormData();
      if (keyword === "multi") {
        for (let i = 0; i < images.length; i++) {
          fd.append("image", images[i]); // Append each file
        }
      } else {
        fd.append("image", images); // Single image
      }
      fd.append("keyword", keyword);
      const response = await server_post_data(save_image_pdf_dashboard, fd);

      if (response.data.error) {
        handleError(response.data.message);
        if (keyword === "single") {
          setStep2Error((prev) => ({ ...prev, [field]: false }));
        }
        if (keyword === "multi") {
          setstep3Error((prev) => ({ ...prev, [field]: false }));
        }
      } else {
        let data = response.data.message.image;
        if (keyword === "single") {
          setFormData((prevData) => ({
            ...prevData,
            [field]: data,
          }));
        }
        if (keyword === "multi") {
          setFormData((prevData) => ({
            ...prevData,
            [field]: [...(prevData[field] || []), ...data],
          }));
          // setstep3Error((prev) => ({ ...prev, [field]: false }));
        }
      }
      setImageLink(APL_LINK + response.data.message.image_link);
    } catch (error) {
      handleError("network");
    } finally {
      setshowLoaderAdmin(false);
    }
  };

  return (
    <div>
      <Header />
      {showLoaderAdmin && <Loader />}
      <div className="container-lg">
        <div className="pageCntn_head p-0 mt-2">
          <div className="pageNameDiv">
            <Breadcrumb
              items={[
                { label: "Bookings", path: "/Bookings" },
                { label: "Drop-off From ", path: "/DropOfForm/:id" },
              ]}
            />
          </div>
          <Button
            onClick={goBack}
            startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
            className="Back_bttn_page"
          >
            Back
          </Button>
        </div>

        <div className="mb-2 form-container PickUpFormContnr">
          {/*---------------------------step -1 --------------------- */}
          {activeStep === 1 && (
            <>
              <form>
                <div className="form-step">
                  <h6>Step 1: Drop Overview & Vehicle Info</h6>

                  <div className="row">
                    <div className="col-md-6 mb-3 ">
                      <label>
                        Submitter
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={formData.Submitter}
                        className="form-control submit_pdding"
                        onChange={(e) => handleInputChange(e, "Submitter", 1)}
                        onInput={handleAphabetsChange}
                      ></input>
                      {step1Error.Submitter && (
                        <span style={{ color: "red" }}>
                          Please fill this field
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>
                        Drop-Off Date
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <DatePicker
                          selected={formData.drop_of_date}
                          onChange={(date) => {
                            const formattedDate = date
                              ? `${date.getFullYear()}-${String(
                                  date.getMonth() + 1
                                ).padStart(2, "0")}-${String(
                                  date.getDate()
                                ).padStart(2, "0")}`
                              : "";
                            handleDateChange(
                              formattedDate,
                              "drop_of_date",
                              setStep1Error
                            );
                          }}
                          open={isDatePickerOpen}
                          dateFormat="MM-dd-yyyy"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className="search-input datepicker form-control"
                          onClickOutside={() => setIsDatePickerOpen(false)}
                          minDate={new Date()}
                          maxDate={new Date()}
                        />
                        <Calendar
                          className="CalnderIcon"
                          strokeWidth={1.5}
                          onClick={toggleDatePicker}
                        />
                      </div>

                      {step1Error.drop_of_date && (
                        <span style={{ color: "red" }}>
                          Please fill this field
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 mb-3 d-flex flex-column">
                      <label className="insncE_lbl">
                        Insurance
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <ButtonGroup
                        className="insurenceBttnGrp"
                        variant="outlined"
                        aria-label="Insurance Options"
                      >
                        <Button
                          className={`${
                            formData.insurance === "Tripcity" ? "active" : ""
                          } insurance-btn`}
                          onClick={() =>
                            handleInputChange(
                              { target: { value: "Tripcity" } },
                              "insurance",
                              1
                            )
                          }
                        >
                          Tripcity
                        </Button>
                        <Button
                          className={`${
                            formData.insurance === "Direct" ? "active" : ""
                          } insurance-btn`}
                          onClick={() =>
                            handleInputChange(
                              { target: { value: "Direct" } },
                              "insurance",
                              1
                            )
                          }
                        >
                          Direct
                        </Button>
                      </ButtonGroup>
                      {step1Error.insurance && (
                        <span style={{ color: "red" }}>
                          Please select an option
                        </span>
                      )}
                    </div>

                    <div className="col-md-6 mb-3 time_Div_contr">
                      <label className="insncE_lbl">
                        Time
                        <span style={{ color: "red" }}>*</span>
                      </label>

                      <select
                        className="form-select time_custm_pdding"
                        value={formData.time}
                        onChange={(e) => handleInputChange(e, "time", 1)}
                      >
                        <option value="" disabled>
                          Select Time
                        </option>
                        <option value="Morning">Morning</option>
                        <option value="Evening">Evening</option>
                        <option value="Late Night">Late Night</option>
                      </select>
                      {step1Error.time && (
                        <span style={{ color: "red" }}>
                          Please select an option
                        </span>
                      )}
                    </div>
                    <div className="col-md-12 mb-3 carDetlCntr">
                      <label className="insncE_lbl">All Car Details</label>
                      <p>
                        {carData.car_tagline} / {carData.car_name} / LP#: {carData.car_no} / VIN#:{" "}
                        {carData.vin} / Make Year: {carData.make_year} / Model:{" "}
                        {carData.model_name}
                      </p>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="">
                        Fist Name
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        value={formData.first_name}
                        className="form-control fistName_custm_pdding"
                        onInput={handleAphabetsChange}
                        onChange={(e) => handleInputChange(e, "first_name", 1)}
                        maxLength={50}
                      ></input>
                      {step1Error.first_name && (
                        <span style={{ color: "red" }}>
                          Please fill this field
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>
                        Last Name
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        className="form-control"
                        value={formData.last_name}
                        onInput={handleAphabetsChange}
                        onChange={(e) => handleInputChange(e, "last_name", 1)}
                      ></input>
                      {step1Error.last_name && (
                        <span style={{ color: "red" }}>
                          Please fill this field
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </form>

              <div className="Next_preV_bck_bttn">
                <div className="nextBttnDiv">
                  <Button onClick={handleNext} color="primary">
                    Next
                  </Button>
                </div>
              </div>
            </>
          )}
          {/*---------------------------step -2 --------------------- */}

          {activeStep === 2 && (
            <>
              <form>
                {" "}
                <div className="form-step">
                  <h6>Step 2 : Vehicle Condition & Verification</h6>
                  <div className="row">
                    <div className="col-md-6 mb-3 car_img_upload_contrr">
                      <label className="insncE_lbl">
                        Picture of Dashboard (ODO & GAS)
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      {!formData.dashboardOdoImage ||
                      formData.dashboardOdoImage.length === 0 ? (
                        <input
                          id="dashboardOdoImageInput"
                          type="file"
                          className="form-control file_custm_Pdding"
                          accept="image/*"
                          onChange={(e) => {
                            handleFileChange(e, "dashboardOdoImage");
                          }}
                        />
                      ) : (
                        <div className="image-preview">
                          <img
                            src={imageLink + formData.dashboardOdoImage}
                            alt="Preview"
                            style={{ height: "100px", width: "100px" }}
                          />
                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg(
                                "dashboardOdoImage",
                                "dashboardOdoImageInput"
                              )
                            }
                          />
                        </div>
                      )}
                      {step2Error.dashboardOdoImage && (
                        <span style={{ color: "red" }}>
                          Please upload an image
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      {" "}
                      <label className="insncE_lbl">
                        Odometer Reading (ODO)
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        value={formData.odoReading}
                        className="form-control"
                        onInput={handleNumbersChange}
                        maxLength={10}
                        onChange={(e) => handleInputChange(e, "odoReading", 2)}
                      ></input>
                      {step2Error.odoReading && (
                        <span style={{ color: "red" }}>
                          Please fill this field
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>
                        Picture of Inside (If the Car is Dirty) (Optional)
                      </label>
                      {!formData.dirty_car_img ||
                      formData.dirty_car_img.length === 0 ? (
                        <input
                          id="dirty_car_img"
                          type="file"
                          className="form-control file_custm_Pdding4"
                          onChange={(e) => handleFileChange(e, "dirty_car_img")}
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                        />
                      ) : (
                        <div className="image-preview">
                          <img
                            src={imageLink + formData.dirty_car_img}
                            alt="Preview"
                            style={{ height: "100px", width: "100px" }}
                          />
                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg(
                                "dirty_car_img",
                                "dirty_car_img"
                              )
                            }
                          />
                        </div>
                      )}
                    </div>

                    <div className="col-md-6 mb-3">
                      {" "}
                      <label className="insncE_lbl">
                        IPASS #<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={formData.ipass}
                        className="form-control ipas_custm_pdding"
                        onInput={handleNumbersChange}
                        onChange={(e) => handleInputChange(e, "ipass", 2)}
                        maxLength={5}
                        readOnly={true}
                      />
                      {step2Error.ipass && (
                        <span style={{ color: "red" }}>
                          {formData.ipass.trim() === ""
                            ? "Please fill this field"
                            : "IPASS must be exactly 5 digits"}
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 mb-3 ">
                      <label>
                        IPASS Picture (Showing the IPASS Number)
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      {!formData.ipassImg || formData.ipassImg.length === 0 ? (
                        <input
                          id="ipassImg"
                          type="file"
                          className="form-control file_custm_Pdding4"
                          onChange={(e) => handleFileChange(e, "ipassImg")}
                          accept=".png, .jpg, .jpeg, .heic, .heif, .webp"
                        />
                      ) : (
                        <div className="image-preview">
                          <img
                            src={imageLink + formData.ipassImg}
                            alt="Preview"
                            style={{ height: "100px", width: "100px" }}
                          />
                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg("ipassImg", "ipassImg")
                            }
                          />
                        </div>
                      )}
                      {step2Error.ipassImg && (
                        <span style={{ color: "red" }}>
                          Please upload an image
                        </span>
                      )}
                    </div>
                    <div className="col-md-6 mb-3 ">
                      <label>
                        Picture of the Key (Showing All Buttons)
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      {!formData.keyImg || formData.keyImg.length === 0 ? (
                        <input
                          id="keyImg"
                          type="file"
                          className="form-control file_custm_Pdding4"
                          onChange={(e) => handleFileChange(e, "keyImg")}
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                        />
                      ) : (
                        <div className="image-preview">
                          <img
                            src={imageLink + formData.keyImg}
                            alt="Preview"
                            style={{ height: "100px", width: "100px" }}
                          />
                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg("keyImg", "keyImg")
                            }
                          />
                        </div>
                      )}
                      {step2Error.keyImg && (
                        <span style={{ color: "red" }}>
                          Please upload an image
                        </span>
                      )}
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Key Status (Optional)</label>
                      <select
                        className="form-select keyStus_cutumn_pdding"
                        value={formData.keyStatus}
                        onChange={(e) => handleInputChange(e, "keyStatus", 2)}
                      >
                        <option value="" disabled>
                          Select Key status
                        </option>
                        <option value="Received Back">Received Back</option>
                        <option value=" Not Received (Tripcity)">
                          {" "}
                          Not Received (Tripcity)
                        </option>
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="margin_cls_VIn_lbl">
                        Match Last 6 Digits of VIN with Insurance ID
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control Cutm_Vin_pdding"
                        value={formData.vinnumber}
                        onInput={handleNumbersChange}
                        onChange={(e) => handleInputChange(e, "vinnumber", 2)}
                        maxLength={6}
                      />
                      {step2Error.vinnumber && (
                        <span style={{ color: "red" }}>
                          {formData.vinnumber.trim() === ""
                            ? "Please fill this field"
                            : "VIN must be exactly 6 digits"}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </form>
              <div className="Next_preV_bck_bttn">
                {" "}
                <div className="nextBttnDiv">
                  <div className="nextBttnDiv">
                    <Button
                      className="back_step_btn"
                      onClick={handleBack}
                      color="primary"
                    >
                      Back
                    </Button>
                  </div>
                </div>
                <div className="nextBttnDiv">
                  <Button onClick={handleNext2} color="primary">
                    Next
                  </Button>
                </div>
              </div>
            </>
          )}

          {/*---------------------------step -3 --------------------- */}
          {activeStep === 3 && (
            <>
              <form>
                <div className="form-step">
                  <h6>Step 3 : Final Checks & Remarks</h6>
                  <div className="row">
                    <label className="picture_car_lbl">
                      {" "}
                      Pictures of the car
                    </label>
                    {/* Front Left */}
                    <div
                      className={
                        !formData.frontLeft
                          ? "col-md-6 col-lg-3 mb-3"
                          : "col-md-3 col-lg-2 mb-3"
                      }
                    >
                      <label htmlFor="frontLeftImage" className="form-label">
                        Driver Left <span style={{ color: "red" }}>*</span>
                      </label>
                      {!formData.frontLeft ||
                      formData.frontLeft.length === 0 ? (
                        <input
                          id="frontLeftImage"
                          type="file"
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                          className="form-control file_custm_Pdding"
                          onChange={(e) => handleFileChange(e, "frontLeft")}
                        />
                      ) : (
                        <div
                          className="image-preview mt-2"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={imageLink + formData.frontLeft}
                            alt="Front Left"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "6px",
                            }}
                          />

                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg(
                                "frontLeft",
                                "frontLeft"
                              )
                            }
                          />
                        </div>
                      )}
                      {step3Error.frontLeft && (
                        <span style={{ color: "red", fontSize: "13px" }}>
                          Please upload Driver Left image
                        </span>
                      )}
                    </div>
                    {/* Front Right */}
                    <div
                      className={
                        !formData.frontRight
                          ? "col-md-6 col-lg-3 mb-3"
                          : "col-md-3 col-lg-2 mb-3"
                      }
                    >
                      <label htmlFor="frontRightImage" className="form-label">
                        Front Right <span style={{ color: "red" }}>*</span>
                      </label>
                      {!formData.frontRight ||
                      formData.frontRight.length === 0 ? (
                        <input
                          id="frontRightImage"
                          type="file"
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                          className="form-control file_custm_Pdding"
                          onChange={(e) => handleFileChange(e, "frontRight")}
                        />
                      ) : (
                        <div
                          className="image-preview mt-2"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={imageLink + formData.frontRight}
                            alt="Front Right"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "6px",
                            }}
                          />

                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg("frontRight")
                            }
                          />
                        </div>
                      )}
                      {step3Error.frontRight && (
                        <span style={{ color: "red", fontSize: "13px" }}>
                          Please upload Front Right image
                        </span>
                      )}
                    </div>
                    {/* Back Left */}
                    <div
                      className={
                        !formData.backLeft
                          ? "col-md-6 col-lg-3 mb-3"
                          : "col-md-3 col-lg-2 mb-3"
                      }
                    >
                      <label htmlFor="backLeftImage" className="form-label">
                        Passanger Left <span style={{ color: "red" }}>*</span>
                      </label>
                      {!formData.backLeft || formData.backLeft.length === 0 ? (
                        <input
                          id="backLeftImage"
                          type="file"
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                          className="form-control file_custm_Pdding"
                          onChange={(e) => handleFileChange(e, "backLeft")}
                        />
                      ) : (
                        <div
                          className="image-preview mt-2"
                          style={{ position: "relative" }}
                        >
                          <img
                            src={imageLink + formData.backLeft}
                            alt="Back Left"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "6px",
                            }}
                          />

                          <X
                            className="removeBttn"
                            size={18}
                            onClick={() =>
                              handleRemoveImageSingleImg("backLeft")
                            }
                          />
                        </div>
                      )}
                      {step3Error.backLeft && (
                        <span style={{ color: "red", fontSize: "13px" }}>
                          Please upload Passanger Left image
                        </span>
                      )}
                    </div>

                    {/* Back Right */}
                    <div
                      className={
                        !formData.backRight
                          ? "col-md-6 col-lg-3 mb-3"
                          : "col-md-3 col-lg-2 mb-3"
                      }
                    >
                      <label htmlFor="backRightImage" className="form-label">
                        Passanger Right <span style={{ color: "red" }}>*</span>
                      </label>
                      {!formData.backRight ||
                      formData.backRight.length === 0 ? (
                        <input
                          id="backRightImage"
                          type="file"
                          accept=".png, .jpg, .jpeg, .heic, .heif"
                          className="form-control file_custm_Pdding"
                          onChange={(e) => handleFileChange(e, "backRight")}
                        />
                      ) : (
                        <div
                          className="image-preview mt-2"
                          onMouseEnter={() => setHoveredIndex("backRight")}
                          onMouseLeave={() => setHoveredIndex(null)}
                          style={{ position: "relative" }}
                        >
                          <img
                            src={imageLink + formData.backRight}
                            alt="Back Right"
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "6px",
                            }}
                          />
                          {hoveredIndex === "backRight" && (
                            <X
                              className="removeBttn"
                              size={18}
                              onClick={() =>
                                handleRemoveImageSingleImg("backRight")
                              }
                            />
                          )}
                        </div>
                      )}
                      {step3Error.backRight && (
                        <span style={{ color: "red", fontSize: "13px" }}>
                          Please upload Passanger Right image
                        </span>
                      )}
                    </div>
                    {/* <div className="col-md-6 mb-3 car_img_upload_contrr">
                                            <label>
                                                Pictures of the car from Front Left (Front Right), Back Right (Back Left).
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                id="carImageInput"
                                                type="file"
                                                className="form-control file_custm_Pdding"
                                                onChange={(e) => handleImageChange(e, "carImage")}
                                                multiple
                                                accept=".png, .jpg, .jpeg, .heic, .heif"
                                            />
                                            {step3Error.carImage && (
                                                <span style={{ color: "red" }}>
                                                    Please upload an image
                                                </span>
                                            )}
                                            {formData.carImage.length > 0 && (
                                                <div className="image-previews">
                                                    {formData.carImage.map((file, index) => (
                                                        <div
                                                            key={index}
                                                            className="image-preview"
                                                            onMouseEnter={() => setHoveredIndex(index)}
                                                            onMouseLeave={() => setHoveredIndex(null)}
                                                        >
                                                            <img
                                                                src={URL.createObjectURL(file)}
                                                                alt={`preview-${index}`}
                                                            />
                                                            {hoveredIndex === index && (
                                                                <X
                                                                    className="removeBttn"
                                                                    size={18}
                                                                    onClick={() =>
                                                                        handleRemoveImage(index, "carImage")
                                                                    }
                                                                />
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div> */}
                    <div
                      className={
                        formData.claims === "yes"
                          ? "col-md-12 mb-3"
                          : "col-md-6 mb-3"
                      }
                    >
                      <label>
                        Claims
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="claim_div_input">
                        <label style={{ cursor: "pointer" }}>
                          <input
                            type="radio"
                            name="claims"
                            value="yes"
                            onChange={handleClaimsChange}
                            checked={formData.claims === "yes"}
                            style={{ cursor: "pointer" }}
                          />
                          Yes
                        </label>
                        <label style={{ cursor: "pointer" }}>
                          <input
                            type="radio"
                            name="claims"
                            value="no"
                            onChange={handleClaimsChange}
                            checked={formData.claims === "no"}
                            style={{ cursor: "pointer" }}
                          />
                          No
                        </label>
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Notes (Additional Comments)</label>
                      <textarea
                        name="notes"
                        type="text"
                        className="form-control noteSection"
                        value={formData.notes}
                        onChange={handleChangeNotes}
                      ></textarea>
                    </div>
                    {formData.claims === "yes" && (
                      <div className="col-md-6 mb-3 time_Div_contr">
                        <label className="insncE_lbl">
                          Claim types include
                          {/* <span style={{ color: "red" }}>*</span> */}
                        </label>

                        <select
                          className="form-select time_custm_pdding"
                          value={formData.claims_type}
                          onChange={(e) =>
                            handleInputChange(e, "claims_type", 1)
                          }
                        >
                          <option value="" disabled>
                            Select Claims Type
                          </option>
                          <option value="Unpaid Rent">Unpaid Rent</option>
                          <option value="Gas">Gas</option>
                          <option value="Damage">Damage</option>
                          <option value="Cleaning">Cleaning</option>
                          <option value="Tolls">Tolls</option>
                        </select>
                        {/* {step3Error.time && (
                                                    <span style={{ color: "red" }}>
                                                        Please select an option
                                                    </span>
                                                )} */}
                      </div>
                    )}

                    {formData.claims_type === "Damage" && (
                      <>
                        <div className="col-md-6 mb-3">
                          <label>Damage Details</label>
                          <textarea
                            name="Damagenotes"
                            type="text"
                            className="form-control noteSection"
                            value={formData.Damagenotes}
                            onChange={handleChangeNotes}
                          ></textarea>
                        </div>
                        <div className="col-md-6 mb-3 car_img_upload_contrr">
                          <label>Damage Pictures</label>
                          <p className="max_upd_img_note">
                            You can upload up to 5 images only.
                          </p>

                          {/* Hidden input always present for triggering on label click */}
                          <input
                            id="damageImageInput"
                            type="file"
                            className="form-control file_custm_Pdding"
                            style={{ display: "none" }}
                            onChange={(e) => handleImageChange(e, "DamgeImage")}
                            multiple
                            accept=".png, .jpg, .jpeg, .heic, .heif, .webp"
                          />

                          {/* Show visible input only when there are no images */}
                          {(!formData.DamgeImage ||
                            formData.DamgeImage.length === 0) && (
                            <input
                              type="file"
                              className="form-control file_custm_Pdding"
                              onChange={(e) =>
                                handleImageChange(e, "DamgeImage")
                              }
                              multiple
                              accept=".png, .jpg, .jpeg, .heic, .heif, .webp"
                            />
                          )}

                          {step3Error.DamgeImage && (
                            <span style={{ color: "red" }}>
                              Please upload an image
                            </span>
                          )}

                          {/* Image preview and Add More box */}
                          {formData.DamgeImage &&
                            formData.DamgeImage.length > 0 && (
                              <div className="image-previews d-flex flex-wrap gap-2 mt-2">
                                {formData.DamgeImage.map((file, index) => (
                                  <div
                                    key={index}
                                    className="image-preview"
                                    style={{ position: "relative" }}
                                  >
                                    <img
                                      src={imageLink + file}
                                      // src={URL.createObjectURL(file)}
                                      alt={`preview-${index}`}
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        borderRadius: "6px",
                                        objectFit: "cover",
                                      }}
                                    />
                                    <X
                                      className="removeBttn"
                                      size={18}
                                      onClick={() =>
                                        handleRemoveImage(index, "DamgeImage")
                                      }
                                    />
                                  </div>
                                ))}

                                {/* Add More Box (click triggers file input) */}
                                {formData.DamgeImage.length < 5 && (
                                  <label
                                    htmlFor="damageImageInput"
                                    className="add-more-box"
                                  >
                                    + Add More
                                  </label>
                                )}
                              </div>
                            )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </form>

              <div className="Next_preV_bck_bttn">
                {" "}
                <div className="nextBttnDiv">
                  <div className="nextBttnDiv">
                    <Button
                      className="back_step_btn"
                      onClick={handleBack}
                      color="primary"
                    >
                      Back
                    </Button>
                  </div>
                </div>
                <div className="nextBttnDiv">
                  <Button onClick={handleNext3} color="primary">
                    Submit
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
